import { render, staticRenderFns } from "./History2.vue?vue&type=template&id=91404114&scoped=true&"
import script from "./History2.vue?vue&type=script&lang=js&"
export * from "./History2.vue?vue&type=script&lang=js&"
import style0 from "./History2.vue?vue&type=style&index=0&id=91404114&lang=scss&scoped=true&"
import style1 from "./History2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91404114",
  null
  
)

export default component.exports